import {logInfo} from "./logging";

export const GIFTCARDPRODUCT = 'Gift Card';
export const GIFTCARDSKU = '999999999';

export function giftcardLineItem(item) {
  if (item.product_type !== GIFTCARDPRODUCT) {
    return item;
  }
  logInfo(item, 'Gift card SKU processed');
  return Object.assign({}, item, {
    sku: GIFTCARDSKU
  });
}

export function giftcardLineItems(items) {
  if (!items || !items.length) {
    return items;
  }
  return cart.items.map(item => giftcardLineItem(item));
}